import _implicitStylesheets from "./suggestionOption.css";
import _implicitScopedStylesheets from "./suggestionOption.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "listed-suggestion": true
};
const stc1 = {
  classMap: {
    "magnifier-icon": true
  },
  props: {
    "icon": "search",
    "size": "small"
  },
  key: 1
};
const stc2 = {
  classMap: {
    "suggestion-text": true
  },
  attrs: {
    "data-testid": "suggestion-text"
  },
  context: {
    lwc: {
      dom: "manual"
    }
  },
  key: 2
};
const stc3 = {
  classMap: {
    "arrow-icon": true
  },
  props: {
    "icon": "forward",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 3
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element} = $api;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "data-item": $cmp.suggestion.suggestedKeyword,
      "data-testid": "suggestion-option"
    },
    key: 0
  }, [api_custom_element("ax-icon", _axIcon, stc1), api_element("span", stc2), api_custom_element("ax-icon", _axIcon, stc3)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-c2ddgasjql";
tmpl.legacyStylesheetToken = "undefined-_suggestionOption";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
